import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login.vue';
import store from '@/store';
// import Admin from './views/Admin.vue';
// import Installations from './views/Installations.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    alias: '/login',
    name: 'login',
    component: Login,
    meta: { noAuth: true }
  },
  {
    path: '/logout',
    name: 'LogOut',
    component: () => import(/* webpackChunkName: "logout" */ './components/Logout.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/admin',
    component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
    meta: { adminAuth: true, residentAuth: false },
    children: [
      {
        path: '',
        redirect: '/admin/dashboard'
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "Dashboard" */ './views/Admin/Dashboard.vue'),
        meta: { adminAuth: true, residentAuth: false }
      },
      {
        path: 'installations',
        name: 'installations',
        component: () =>
          import(/* webpackChunkName: "Installations" */ './views/Admin/Installations.vue'),
        meta: { adminAuth: true, residentAuth: false }
      },
      {
        path: 'installations/add',
        name: 'addInstallation',
        component: () =>
          import(/* webpackChunkName: "InstallationEdit" */ './views/Admin/InstallationEdit.vue'),
        meta: { adminAuth: true, residentAuth: false }
      },
      {
        path: 'installations/upload',
        name: 'uploadInstallations',
        component: () =>
          import(/* webpackChunkName: "InstallationUpload" */ './views/Admin/InstallationUpload.vue'),
        meta: { adminAuth: true, residentAuth: false }
      },
      {
        path: 'installations/:id',
        name: 'editInstallation',
        component: () =>
          import(/* webpackChunkName: "InstallationEdit" */ './views/Admin/InstallationEdit.vue'),
        meta: { adminAuth: true, residentAuth: false }
      }
    ]
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.noAuth) {
    next();
  } else {
    const authUser = store.getters.currentUser;

    if (!authUser) {
      next({ name: 'login' });
    } else if (to.meta.adminAuth) {
      // requires admin role
      if (authUser.role === 'admin') {
        next();
      } else {
        /**
         *  TODO: redirect to not enough permissions page
         * */
        next('/dashboard');
      }
    }
  }
});

export default router;
